Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAsleepData: "data:image/svg+xml,%3csvg width='17' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M16.329 9.065A8.522 8.522 0 01.7 11.942a1.182 1.182 0 011.012-1.811 8.618 8.618 0 002.13-.16 8.522 8.522 0 006.765-8.778A1.182 1.182 0 0112.42.18a8.522 8.522 0 013.91 8.884z' fill='currentColor' fill-rule='nonzero'/%3e%3c/svg%3e",
  iconAsleepWidth: 17,
  iconAsleepHeight: 16
};